import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const MediaFeaturesServiceContext = createContext(undefined)

const MediaFeaturesServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={MediaFeaturesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api/v1/content/media_features`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/content/media_features/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/content/media_features${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/content/media_features/${id}`, payload)
          return data
        },
        delete: async (id) => {
          const {data} = await axios.delete(`/api/v1/content/media_features/${id}`)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

MediaFeaturesServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useMediaFeaturesService = () => {
  const context = useContext(MediaFeaturesServiceContext)
  if (context === undefined) {
    throw new Error('MediaFeaturesServiceContext was not provided. Make sure your component is a child of the MediaFeaturesServiceProvider.')
  }
  return context
}

const useMediaFeaturesQuery = ({query, ...otherProps}) => {
  const mediaFeaturesService = useMediaFeaturesService()
  return useSimpleQuery({
    queryKey: `media_features-list-${JSON.stringify(query)}`,
    queryFn: async () => mediaFeaturesService.list(query),
    ...otherProps
  })
}

const useMediaFeatureQuery = ({id, enabled, ...otherProps}) => {
  const mediaFeaturesService = useMediaFeaturesService()
  return useSimpleQuery({
    queryKey: `media_features-get-${id}`,
    queryFn: async () => mediaFeaturesService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {MediaFeaturesServiceProvider, useMediaFeaturesService, useMediaFeaturesQuery, useMediaFeatureQuery}
